export const SEARCH_TAG_KEY = "tags"
export const SEARCH_SORT_KEY = "sort"
export const SEARCH_GENDER_KEY = "gender"
export const SEARCH_NSFW_KEY = "nsfw"
export const SEARCH_ANONYMOUS_KEY = "anonymous"
export const SEARCH_RICHNESS_KEY = "info_token"
export const SEARCH_LANGUAGE_KEY = "language"

